import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
// import MuiDataTableCSS from '../../Styles/MuiDataTable';
import PropTypes from "prop-types";
import api from "../../assets/constants/Rafservice.Instance";
// //import { TableRow } from '@mui/material';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
    createMuiTheme,
    MuiThemeProvider,
    withStyles
} from "@material-ui/core/styles";
const ServerSideGridTableN = (props) => {

    const { url, columns, tableClick, defaultSortCol, defaultSortDir, className } = props;

    const [rowdata, setRowdata] = useState(['Loading Data...']);
    const [count, setCount] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(10);
    const [Page] = useState(0);
    const [sortOrder] = useState({});
    const [col] = useState(defaultSortCol ? defaultSortCol : 0);
    const [Dir] = useState(defaultSortDir ? defaultSortDir : "asc");
    const [Search] = useState("");
    const [ColumnSearch] = useState("");
    const [TableAfterSearch, setTableAfterSearch] = useState(false);
    const [rowdataCSV, setrowdataCSV] = useState(['Downloading Data...']);

    const data = [
        ["Joe James", "Test Corp", "Yonkers", "NY"],
        ["John Walsh", "Test Corp", "Hartford", "CT"],
        ["Bob Herm", "Test Corp", "Tampa", "FL"],
        ["James Houston", "Test Corp", "Dallas", "TX"],
    ];
    const columnsdata = ["Name", "Company", "City", "State"];

    const loadTable = (pageNo, rowsOnPage, col, dir, searchtxt, columnSearch) => {
        api.get(`${url}?iDisplayStart=${pageNo * rowsOnPage}&iDisplayLength=${rowsOnPage}&iSortCol_0=${col}&sSortDir_0=${dir}&sSearch=${searchtxt}&columnSearch=${columnSearch}`)
            .then(res => {

                setRowdata(res.aaData);
                //setCount(res.iTotalRecords);
                setCount(res.iTotalDisplayRecords);
                props.rowData(res.aaData);
            })
            .catch(err => {
                // console.log(err);
            })

    }
    const downloadTable = (pageNo, rowsOnPage, col, dir, searchtxt, columnSearch) => {
        api.get(`${url}?iDisplayStart=${pageNo * rowsOnPage}&iDisplayLength=${rowsOnPage}&iSortCol_0=${col}&sSortDir_0=${dir}&sSearch=${searchtxt}&columnSearch=${columnSearch}`)
            .then(res => {
                setrowdataCSV(res.aaData);
            })
            .catch(err => {
                // console.log(err);
            })

    }



    const ObjectToFindValue = (objectName, keyName) => {
        // console.log('ObjectToFindValue');
        for (let [key, value] of Object.entries(objectName)) {
            if (key === keyName) {
                // console.log(`${key}: ${value}`);
                return value;
            }
        }
    }

    const DefaultOptions = {
        filter: props.filter ? props.filter : false,
        filterType: 'dropdown',
        responsive: 'standard',
        tableBodyHeight: 'auto',
        tableBodyMaxHeight: '900px',
        selectableRows: false,
        serverSide: true,
        count: count,
        responsive: 'stacked',
        rowsPerPage: RowPerPage,
        rowsPerPageOptions: [10, 25, 50, 100],
        sortOrder: sortOrder,
        downloadOptions: {
            filename: 'Download.csv'
        },
        onCellClick: (colData, cellMeta) => {
            //    console.log(colData,cellMeta);
            if (props.tableClick) {
                tableClick(rowdata, colData, cellMeta);
            }

        },

        onDownload: (buildHead, buildBody, columns, data) => {
            //downloadTable(Page,count,col,Dir,Search);
            let values = [];
            var AllDataArray = []
            let rowArray = [];
            columns.forEach(columnInside => {

                values.push(columnInside.name)
            })
            rowdataCSV.forEach((element, index) => {
                rowArray = [];
                values.forEach((el, i) => {
                    rowArray.push(ObjectToFindValue(element, el));
                });
                AllDataArray.push({ index: index, data: rowArray });
            });
            //data = toArray(filterRowObject)

            return "\uFEFF" + buildHead(columns) + buildBody(AllDataArray);
        },
        onTableChange: (action, tableState) => {

            let filterColumnObject = [];
            let columnArray = [];
            //multiple filter
            if (props.filter == true && action == 'filterChange' && tableState.columns && tableState.filterList) {
                tableState.columns.forEach(element => {
                    if (element.name) {
                        columnArray.push(element.name)
                    }
                });
                if (columnArray && columnArray.length > 0) {
                    tableState.filterList.forEach((element, index) => {
                        if (element && element[0]) {
                            filterColumnObject.push({ [columnArray[index]]: element[0] })
                        }
                    });
                }
                // console.log("filterColumnObject "+filterColumnObject)
            }

            switch (action) {
                case "changePage":
                    loadTable(tableState.page, tableState.rowsPerPage, col, Dir, Search, filterColumnObject.length > 0 ? JSON.stringify(filterColumnObject) : ColumnSearch);
                    break;
                case "sort":
                    loadTable(tableState.page, tableState.rowsPerPage, tableState.activeColumn, tableState.sortOrder.direction, Search, filterColumnObject.length > 0 ? JSON.stringify(filterColumnObject) : ColumnSearch);
                    break;
                case "changeRowsPerPage":
                    setRowPerPage(tableState.rowsPerPage);
                    loadTable(tableState.page, tableState.rowsPerPage, col, Dir, Search, filterColumnObject.length > 0 ? JSON.stringify(filterColumnObject) : ColumnSearch);
                    break;
                case "search":
                    setTableAfterSearch(true);
                    loadTable(tableState.page, tableState.rowsPerPage, col, Dir, tableState.searchText ? tableState.searchText : Search, ColumnSearch);
                    break;
                case "filterChange":
                    setTableAfterSearch(true);
                    loadTable(tableState.page, tableState.rowsPerPage, col, Dir, tableState.searchText ? tableState.searchText : Search, filterColumnObject.length > 0 ? JSON.stringify(filterColumnObject) : ColumnSearch);
                    break;
                case "onSearchClose":
                    // setTableAfterSearch(false);
                    // loadTable(tableState.page,tableState.rowsPerPage,col,Dir,Search,ColumnSearch);
                    break;
            }
        },
        //         expandableRows: true,
        //         expandableRowsHeader: false,
        //         renderExpandableRow: (rowdata, columns) => {

        //             /* let values = [];
        //             var AllDataArray= []
        //             let rowArray = [];
        //             console.log("rowdatassss "+JSON.stringify(rowdata))
        //             rowdata.forEach(rowDataInside => {

        //                 values.push(rowDataInside.childClaim)
        //             })           
        //             rowdataCSV.forEach((element, index) => {
        //                 rowArray= [];
        //                 values.forEach((el, i) => {
        //                     rowArray.push(ObjectToFindValue(element, el));
        //                 });
        //                 AllDataArray.push({index:index, data:rowArray});
        //             });
        //  */
        //             return (
        //             <div className={className}>
        //                 <React.Fragment>
        //                     <tr>
        //                         <td colSpan={6}>
        //                             <TableContainer>
        //                                 <Table style={{ minWidth: "950" }} aria-label="simple table">
        //                                     <TableHead>
        //                                     {columnsdata.map(columnsdata => (
        //                                         <TableCell component="th" scope="row">
        //                                             {columnsdata}
        //                                         </TableCell>
        //                                     ))}

        //                                     </TableHead>
        //                                     <TableBody>
        //                                     {data.map(row => (
        //                                         <TableRow key={row}>
        //                                         <TableCell component="th" scope="row">
        //                                           <TableRow>  {row}</TableRow>
        //                                         </TableCell>                                      
        //                                         </TableRow>
        //                                     ))}
        //                                     </TableBody>
        //                                 </Table>
        //                             </TableContainer>
        //                         </td>
        //                     </tr>
        //                 </React.Fragment>
        //             </div>
        //               );
        //         }

    }
    const getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MuiTableCell: {
                    head: {
                        backgroundColor: "rgb(82, 108, 236) !important",
                        color: "rgb(239, 240, 247) !important",
                        fontWeight: "bold !important"
                    },
                    sortOrder: {
                        backgroundColor: "rgb(82, 108, 236) !important",
                        color: "rgb(239, 240, 247) !important",
                        fontWeight: "bold !important"
                    }
                },
                MUIDataTableSelectCell: {
                    headerCell: {
                        backgroundColor: "rgb(82, 108, 236) !important",
                        color: "rgb(239, 240, 247) !important",
                        fontWeight: "bold !important"
                    }
                },
                MUIDataTableHeadCell: {
                    sortActive: {
                        color: "rgb(239, 240, 247) !important",
                    }
                }
            }
        });


    useEffect(() => {
        loadTable(Page, RowPerPage, col, Dir, Search);
    }, [url]);
    useEffect(() => {
        downloadTable(Page, count, col, Dir, Search);
    }, [count]);
    return (
        <div className={className}>
            {(rowdata.length > 0 || TableAfterSearch) ?
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={rowdata}
                        columns={columns}
                        options={DefaultOptions}
                        className={"pb-5"}
                    />
                </MuiThemeProvider>
                :
                <h6 className="text-center">No records found!..</h6>
            }
        </div>

    )
}

ServerSideGridTableN.propTypes = {
    columns: PropTypes.array,
    url: PropTypes.string,
    tableClick: PropTypes.func,
    defaultSortCol: PropTypes.number,
    defaultSortDir: PropTypes.string
}

export default ServerSideGridTableN;
